var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBuildDiscipline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 10.9993C27 12.6563 22.9706 13.9995 18 13.9995C13.0294 13.9995 9 12.6563 9 10.9993M27 10.9993C27 9.34228 22.9706 7.99902 18 7.99902C13.0294 7.99902 9 9.34228 9 10.9993M27 10.9993V25.0004C27 25.7961 26.0518 26.5592 24.364 27.1219C22.6761 27.6845 20.3869 28.0006 18 28.0006C15.6131 28.0006 13.3239 27.6845 11.636 27.1219C9.94821 26.5592 9 25.7961 9 25.0004V10.9993M9 17.9998C9 18.7955 9.94821 19.5587 11.636 20.1213C13.3239 20.684 15.6131 21.0001 18 21.0001C20.3869 21.0001 22.6761 20.684 24.364 20.1213C26.0518 19.5587 27 18.7955 27 17.9998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuildDiscipline);
export default __webpack_public_path__ + "static/media/buildDiscipline.46b3c31c8d7e4be5339b49180117795a.svg";
export { ForwardRef as ReactComponent };